var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _g3, _g4, _path18, _path19, _g5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.261719 8 L 7 8 L 7 11 L 1.261719 11 Z M 1.261719 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 56 L 72 56 L 72 74.011719 L 54 74.011719 Z M 54 56 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 1.261719 L 61 1.261719 L 61 59 L 18 59 Z M 18 1.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 1.261719 L 61 1.261719 L 61 14 L 47 14 Z M 47 1.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.261719 32 L 21 32 L 21 39 L 1.261719 39 Z M 1.261719 32 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 65.960938 8.945312 L 63.515625 8.152344 L 64.21875 5.992188 L 66.664062 6.785156 L 65.960938 8.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 66.183594 12.046875 L 64.347656 10.710938 L 65.859375 8.632812 L 67.695312 9.96875 L 66.183594 12.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 68.878906 12.046875 L 67.367188 9.96875 L 69.207031 8.632812 L 70.714844 10.710938 L 68.878906 12.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 69.105469 8.945312 L 68.40625 6.785156 L 70.847656 5.992188 L 71.546875 8.152344 L 69.105469 8.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 68.667969 6.976562 L 66.398438 6.976562 L 66.398438 4.40625 L 68.667969 4.40625 L 68.667969 6.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 9.253906 66.0625 L 5.847656 66.0625 L 5.847656 63.792969 L 9.253906 63.792969 L 9.253906 66.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 20.605469 66.0625 L 13.792969 66.0625 L 13.792969 63.792969 L 20.605469 63.792969 L 20.605469 66.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 12.660156 62.65625 L 10.390625 62.65625 L 10.390625 59.253906 L 12.660156 59.253906 L 12.660156 62.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 12.660156 70.605469 L 10.390625 70.605469 L 10.390625 67.199219 L 12.660156 67.199219 L 12.660156 70.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 6.984375 10.4375 L 1.304688 10.4375 L 1.304688 8.164062 L 6.984375 8.164062 L 6.984375 10.4375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 13.792969 7.03125 L 6.984375 7.03125 L 6.984375 4.757812 L 13.792969 4.757812 L 13.792969 7.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 38.769531 66.0625 L 35.367188 66.0625 L 35.367188 63.792969 L 38.769531 63.792969 L 38.769531 66.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 43.3125 69.46875 L 38.769531 69.46875 L 38.769531 67.199219 L 43.3125 67.199219 L 43.3125 69.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 47.082031 41.457031 C 45.050781 41.457031 43.011719 42.230469 41.464844 43.78125 C 38.367188 46.878906 38.367188 51.921875 41.464844 55.019531 C 44.5625 58.117188 49.605469 58.117188 52.703125 55.019531 C 54.203125 53.519531 55.03125 51.523438 55.03125 49.402344 C 55.03125 47.277344 54.203125 45.28125 52.703125 43.78125 C 51.152344 42.230469 49.117188 41.457031 47.082031 41.457031 Z M 47.082031 59.613281 C 44.46875 59.613281 41.851562 58.617188 39.859375 56.625 C 35.875 52.640625 35.875 46.160156 39.859375 42.175781 C 43.84375 38.191406 50.324219 38.191406 54.308594 42.175781 C 56.238281 44.105469 57.300781 46.671875 57.300781 49.402344 C 57.300781 52.128906 56.238281 54.695312 54.308594 56.625 C 52.316406 58.617188 49.699219 59.613281 47.082031 59.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.914062 59.835938 L 52.703125 56.625 L 54.308594 55.019531 L 57.519531 58.230469 L 55.914062 59.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 59.125 59.171875 C 58.519531 59.171875 57.949219 59.40625 57.519531 59.835938 C 57.089844 60.265625 56.855469 60.835938 56.855469 61.441406 C 56.855469 62.046875 57.089844 62.617188 57.519531 63.046875 L 65.546875 71.074219 C 66.40625 71.933594 67.902344 71.933594 68.757812 71.074219 C 69.1875 70.644531 69.421875 70.078125 69.421875 69.46875 C 69.421875 68.863281 69.1875 68.292969 68.757812 67.863281 L 60.730469 59.835938 C 60.300781 59.40625 59.730469 59.171875 59.125 59.171875 Z M 67.152344 74.011719 C 65.941406 74.011719 64.796875 73.539062 63.941406 72.679688 L 55.914062 64.652344 C 55.054688 63.796875 54.582031 62.65625 54.582031 61.441406 C 54.582031 60.230469 55.054688 59.089844 55.914062 58.230469 C 57.628906 56.515625 60.621094 56.515625 62.335938 58.230469 L 70.363281 66.257812 C 71.222656 67.117188 71.691406 68.257812 71.691406 69.46875 C 71.691406 70.683594 71.222656 71.820312 70.363281 72.679688 C 69.507812 73.539062 68.367188 74.011719 67.152344 74.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 59.929688 63.851562 L 58.320312 62.246094 L 59.925781 60.640625 L 61.53125 62.246094 L 59.929688 63.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 63.140625 67.0625 L 61.53125 65.457031 L 63.140625 63.851562 L 64.742188 65.457031 L 63.140625 67.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 66.351562 70.273438 L 64.746094 68.667969 L 66.351562 67.0625 L 67.957031 68.667969 L 66.351562 70.273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 37.636719 58.117188 L 18.335938 58.117188 L 18.335938 1.351562 L 49.460938 1.351562 L 60.339844 12.238281 L 60.339844 54.710938 L 58.070312 54.710938 L 58.070312 13.175781 L 48.515625 3.625 L 20.605469 3.625 L 20.605469 55.847656 L 37.636719 55.847656 L 37.636719 58.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 50.121094 11.570312 L 56.464844 11.570312 L 50.121094 5.230469 Z M 59.203125 13.84375 L 48.988281 13.84375 C 48.359375 13.84375 47.851562 13.332031 47.851562 12.707031 L 47.851562 2.488281 C 47.851562 2.03125 48.128906 1.613281 48.550781 1.4375 C 48.976562 1.261719 49.464844 1.359375 49.789062 1.683594 L 60.007812 11.902344 C 60.332031 12.226562 60.429688 12.714844 60.253906 13.140625 C 60.078125 13.566406 59.664062 13.84375 59.203125 13.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 16.066406 16.113281 L 18.335938 16.113281 L 18.335938 13.84375 L 16.066406 13.84375 Z M 20.605469 18.382812 L 13.792969 18.382812 L 13.792969 11.570312 L 20.605469 11.570312 L 20.605469 18.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 9.253906 26.332031 L 18.335938 26.332031 L 18.335938 24.058594 L 9.253906 24.058594 Z M 20.605469 28.601562 L 6.984375 28.601562 L 6.984375 21.789062 L 20.605469 21.789062 L 20.605469 28.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 3.578125 36.546875 L 18.335938 36.546875 L 18.335938 34.277344 L 3.578125 34.277344 Z M 20.605469 38.816406 L 1.304688 38.816406 L 1.304688 32.007812 L 20.605469 32.007812 L 20.605469 38.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 12.660156 46.765625 L 18.335938 46.765625 L 18.335938 44.492188 L 12.660156 44.492188 Z M 20.605469 49.035156 L 10.390625 49.035156 L 10.390625 42.222656 L 20.605469 42.222656 L 20.605469 49.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 29.6875 33.140625 C 26.558594 33.140625 24.011719 35.6875 24.011719 38.816406 C 24.011719 41.949219 26.558594 44.492188 29.6875 44.492188 C 32.816406 44.492188 35.367188 41.949219 35.367188 38.816406 C 35.367188 35.6875 32.816406 33.140625 29.6875 33.140625 Z M 29.6875 46.765625 C 25.304688 46.765625 21.742188 43.199219 21.742188 38.816406 C 21.742188 34.433594 25.304688 30.871094 29.6875 30.871094 C 34.070312 30.871094 37.636719 34.433594 37.636719 38.816406 C 37.636719 43.199219 34.070312 46.765625 29.6875 46.765625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 29.6875 41.558594 L 26.613281 38.484375 L 28.21875 36.878906 L 29.6875 38.347656 L 32.292969 35.746094 L 33.898438 37.347656 L 29.6875 41.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 29.6875 14.976562 C 26.558594 14.976562 24.011719 17.523438 24.011719 20.652344 C 24.011719 23.78125 26.558594 26.332031 29.6875 26.332031 C 32.816406 26.332031 35.367188 23.78125 35.367188 20.652344 C 35.367188 17.523438 32.816406 14.976562 29.6875 14.976562 Z M 29.6875 28.601562 C 25.304688 28.601562 21.742188 25.035156 21.742188 20.652344 C 21.742188 16.273438 25.304688 12.707031 29.6875 12.707031 C 34.070312 12.707031 37.636719 16.273438 37.636719 20.652344 C 37.636719 25.035156 34.070312 28.601562 29.6875 28.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 29.6875 23.390625 L 26.613281 20.320312 L 28.21875 18.714844 L 29.6875 20.183594 L 32.292969 17.578125 L 33.898438 19.183594 L 29.6875 23.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 71.265625 28.554688 L 62.621094 37.203125 L 61.382812 35.972656 L 70.683594 26.675781 C 70.917969 27.285156 71.109375 27.914062 71.265625 28.554688 Z M 70.121094 38.589844 C 69.460938 39.898438 68.613281 41.09375 67.609375 42.152344 L 67.082031 41.628906 Z M 71.691406 32.007812 C 71.691406 32.664062 71.632812 33.3125 71.546875 33.949219 L 65.46875 40.027344 L 64.234375 38.800781 L 71.664062 31.371094 C 71.671875 31.582031 71.691406 31.792969 71.691406 32.007812 Z M 59.367188 15.148438 L 59.046875 17.398438 C 62.167969 17.84375 64.957031 19.277344 67.117188 21.351562 L 58.402344 30.066406 L 60.007812 31.671875 L 68.628906 23.050781 C 68.988281 23.523438 69.328125 24.007812 69.628906 24.515625 L 58.402344 35.746094 L 58.640625 35.980469 L 58.40625 36.21875 L 65.925781 43.679688 C 63.96875 45.199219 61.625 46.246094 59.046875 46.613281 L 59.367188 48.863281 C 67.6875 47.671875 73.964844 40.425781 73.964844 32.007812 C 73.964844 23.585938 67.6875 16.339844 59.367188 15.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 45.582031 9.300781 L 21.742188 9.300781 L 21.742188 7.03125 L 45.582031 7.03125 L 45.582031 9.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 45.582031 13.84375 L 35.367188 13.84375 L 35.367188 11.570312 L 45.582031 11.570312 L 45.582031 13.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.800781 18.382812 L 38.769531 18.382812 L 38.769531 16.113281 L 55.800781 16.113281 L 55.800781 18.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.800781 22.925781 L 38.769531 22.925781 L 38.769531 20.652344 L 55.800781 20.652344 L 55.800781 22.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.800781 27.464844 L 38.769531 27.464844 L 38.769531 25.195312 L 55.800781 25.195312 L 55.800781 27.464844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.800781 32.007812 L 38.769531 32.007812 L 38.769531 29.734375 L 55.800781 29.734375 L 55.800781 32.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 55.800781 36.546875 L 38.769531 36.546875 L 38.769531 34.277344 L 55.800781 34.277344 L 55.800781 36.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 35.367188 52.441406 L 22.878906 52.441406 L 22.878906 50.167969 L 35.367188 50.167969 L 35.367188 52.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#560216",
    d: "M 43.3125 49.035156 L 41.042969 49.035156 C 41.042969 45.90625 43.585938 43.359375 46.71875 43.359375 L 46.71875 45.628906 C 44.839844 45.628906 43.3125 47.15625 43.3125 49.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxAudit);
export default __webpack_public_path__ + "static/media/Tax Audit.8338f2f24a964a537d7eeea295e91ed1.svg";
export { ForwardRef as ReactComponent };